export default "__VITE_ASSET__xGBgHlOq__"